import { ENV } from './env';

type Properties = { [key: string]: unknown };

export function getEventQuery(properties: Properties) {
  return Object.keys(properties).reduce<{
    [key: string]: unknown;
  }>(
    (prev, key) =>
      /^utm_/.test(key) ? { ...prev, [`event_${key}`]: properties[key] } : prev,
    {},
  );
}

export function toSearchObject(urlSearchParams: URLSearchParams) {
  return Array.from(urlSearchParams.entries()).reduce(
    (current, next) => {
      const result = { ...current };
      const [key, value] = next;

      if (!result[key]) {
        result[key] = value;
        return result;
      }

      let theValue = result[key];
      if (Array.isArray(theValue)) {
        theValue.push(value);
      } else {
        theValue = [theValue].concat(value);
      }

      return result;
    },
    {} as Record<string, string | string[]>,
  );
}

export const MARKET_BASE_URL = {
  prod: 'https://market.cashnote.kr',
  stg: 'https://stg-market.cashnote.kr',
  dev: 'https://dev-market.cashnote.kr',
}[ENV];

export const MARKET_API_URL = {
  prod: 'https://market-api.cashnote.kr',
  stg: 'https://stg-market-api.cashnote.kr',
  dev: 'https://dev-market-api.cashnote.kr',
  // dev: 'http://172.16.10.83:8080',
}[ENV];

export const HOME_BASE_URL = {
  prod: 'https://home.cashnote.kr',
  stg: 'https://home.cashnote.kr',
  dev: 'https://dev-home.cashnote.kr',
}[ENV];

export const INTERNAL_MARKET_API_URL = {
  prod: 'http://internal-market-api.cashnote.kr',
  stg: 'http://internal-stg-market-api.cashnote.kr',
  dev: 'http://internal-dev-market-api.cashnote.kr',
}[ENV];

export function isValidUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:';
  } catch {
    return false;
  }
}

// 사업장 등록 url
export const BUSINESS_REGISTER_URL = {
  prod: 'https://apps.cashnote.kr/businesses/check?redirectUrl=https://market.cashnote.kr/app',
  stg: 'https://apps.cashnote.kr/businesses/check?redirectUrl=https://stg-market.cashnote.kr/app',
  dev: 'https://dev-apps.cashnote.kr/businesses/check?redirectUrl=https://dev-market.cashnote.kr/app',
}[ENV];

export const BUSINESS_REPORT_REGISTER_URL = {
  prod: 'https://business-report.cashnote.kr/checkpoint/standard/kcdb2c/apply',
  stg: 'https://business-report.cashnote.kr/checkpoint/standard/kcdb2c/apply',
  dev: 'https://dev-business-report.cashnote.kr/checkpoint/standard/kcdb2c/apply',
}[ENV];
